var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"about"},[_vm._v(" Projeto Fichas para reflexão. Sistema em desenvolvimento pela Diretoria de tecnologia da informação da Universidade Federal de Viçosa (DTI - UFV) ")])}
var staticRenderFns = []

export { render, staticRenderFns }